import React from "react";
import { Link } from "react-router-dom";

const ChangePasswordConfirm = () => {
  return (
    <div className="change-password-confirm">
      <div className="background-wrapper creamy-cement" />
      <h2>Success!</h2>
      <div className="center-box">
        <p>Your password has been reset.</p>
        <Link to="/login">
          <button className="btn btn-primary w-100">Log In</button>
        </Link>
      </div>
    </div>
  );
};

export default ChangePasswordConfirm;
